import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Tab, Tabs } from '@mui/material';
import { BILLING_NAV } from '../../services/billingApi';
import { BillingPageHeader, tones } from './billingUi';

/** Spec §4 navigation — compact colorful tab strip. */
const BillingNav = ({ title, subtitle, actions }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const activePath =
    BILLING_NAV.find(
      (item) =>
        location.pathname === item.path ||
        (item.path !== '/admin/billing' && location.pathname.startsWith(item.path))
    )?.path || '/admin/billing';

  return (
    <Box sx={{ mb: 2.5 }}>
      <BillingPageHeader title={title} subtitle={subtitle} actions={actions} />
      <Box
        sx={{
          bgcolor: '#fff',
          border: '1px solid',
          borderColor: tones.maroon.border,
          borderRadius: 2,
          px: 1,
          overflowX: 'auto',
          boxShadow: '0 1px 2px rgba(15, 23, 42, 0.04)',
        }}
      >
        <Tabs
          value={activePath}
          onChange={(_, path) => navigate(path)}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          sx={{
            minHeight: 46,
            '& .MuiTabs-indicator': { display: 'none' },
            '& .MuiTab-root': {
              minHeight: 38,
              my: 0.5,
              textTransform: 'none',
              fontWeight: 600,
              fontSize: '0.8rem',
              color: tones.slate.text,
              px: 1.75,
              mr: 0.5,
              borderRadius: 1.5,
              transition: 'background-color 0.15s ease, color 0.15s ease',
              '&:hover': {
                bgcolor: tones.maroon.soft,
                color: tones.maroon.text,
              },
            },
            '& .Mui-selected': {
              color: `${tones.maroon.main} !important`,
              bgcolor: tones.maroon.soft,
              fontWeight: 700,
            },
          }}
        >
          {BILLING_NAV.map((item) => (
            <Tab key={item.path} value={item.path} label={item.label} disableRipple />
          ))}
        </Tabs>
      </Box>
    </Box>
  );
};

export default BillingNav;
